export function namespacer(namespace, str) {
  return `${ namespace }_${ str }`;
}


// WEBPACK FOOTER //
// ./src/util/namespace.js